import React, {useEffect} from 'react'
import gsap from 'gsap'

const CardAvatar = ({ image, description, title, name, className }) => {

    useEffect(()=>{
    gsap.fromTo('.card',
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.out',
          stagger: 0.3,
          scrollTrigger: {
            trigger: '.card',
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );  
    },[])

  return (

    <a href='https://www.linkedin.com/in/mario-di-stefano-064b791ab/details/recommendations/?detailScreenTabIndex=0'  target="_blank"
    rel="noreferrer noopener" className={className}>
       <div className="card text-center reference-card shadow-sm " style={{ borderRadius: '10px' }}>
        <div className="card-body m-3">
            <div className=' d-flex  align-items-center mb-3'>
                <img
                    src={image}
                    alt={`${name}'s avatar`}
                    className="rounded-circle"
                    style={{ width: '50px', height: '50px', objectFit: 'cover', border: '4px solid #007bff' }}
                /> 
                <div className='ps-3'>
                    <h5 className="card-title text-start">{name}</h5>
                    <h6 className="card-subtitle  text-start text-muted">{title}</h6>  
                </div>
              </div>
             
               <p style={{'maxHeight':'40vh'}} className="card-text text-start overflow-auto">{description}</p>  
           
           
        </div>
    </div> 
    </a>

  )
}

export default CardAvatar